import { Alert, Button, Popover } from "antd";
import Title from "antd/es/typography/Title";
import React, { FC } from "react";
import {
  OrderStepTrackerResponseItem,
  ProductionOutputMaterial,
} from "shared/api";
import {
  getProductionOutputMaterialInfo,
  openHyperlinkInTab,
} from "shared/helpers";
import { useTranslation } from "react-i18next";

interface UpdatedOutputMaterialHeaderProps {
  outputMaterials: ProductionOutputMaterial[];
  index: number;
  isEditMode: boolean[];
  toggleEditMode: (index: number) => void;
  orderStepTrackerResponseItem?: OrderStepTrackerResponseItem;
  statusSummary: {
    Prima: number;
    Waste: number;
    Investigation: number;
  };
  selectedCount: number;
}

const UpdatedOutputMaterialHeader: FC<UpdatedOutputMaterialHeaderProps> = ({
  outputMaterials,
  index,
  isEditMode,
  toggleEditMode,
  orderStepTrackerResponseItem,
  statusSummary,
  selectedCount,
}) => {
  const { t } = useTranslation("", { keyPrefix: "orders" });

  const { materialLink, materialTitle, isVisibleEditModeButton } =
    getProductionOutputMaterialInfo(
      t,
      index,
      selectedCount,
      outputMaterials,
      orderStepTrackerResponseItem
    );

  const isActiveEditMode = isEditMode?.[index];

  return (
    <div className="w-full flex items-center justify-between p-2">
      <Popover
        className="flex items-center justify-between w-[80%]"
        content={
          <Alert showIcon type="info" message={t("hyperlink-material")} />
        }
      >
        <Title
          level={5}
          onClick={() => openHyperlinkInTab(materialLink)}
          className="!text-blue-500 hover:underline cursor-pointer"
        >
          {materialTitle}
        </Title>
        <div className="w-32 flex gap-3">
          <div className="!text-green-100 flex items-center">
            <strong>{t("prima")}</strong>:&nbsp;{statusSummary.Prima}
          </div>
          <div className="!text-red-300 flex items-center">
            <strong>{t("wasted")}</strong>:&nbsp;{statusSummary.Waste}
          </div>
          <div className="!text-yellow-600 flex items-center">
            <strong>{t("investigation")}</strong>:&nbsp;
            {statusSummary.Investigation}
          </div>
        </div>
      </Popover>

      {isVisibleEditModeButton ? (
        <Button
          onClick={() => toggleEditMode(index)}
          type="primary"
          className="btn-primary--dark h-10 !bg-blue-500 hover:!brightness-150 text-[18px]"
        >
          {isActiveEditMode ? t("hideEditMode") : t("showEditMode")}
        </Button>
      ) : null}
    </div>
  );
};

export { UpdatedOutputMaterialHeader };
